module.exports = __webpack_public_path__ + "img/galapagos-islands.e5c47786.svg";